// extracted by mini-css-extract-plugin
export default {"app":"d6WLOcTu8Dn56sG4Ft2_"};